import { TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';
import { KokonIcon16 } from './internal/components/KokonIcon16';
import { KokonTooltipContent } from './internal/components/KokonTooltipContent';
import * as styles from './KokonTooltipIcon.css';

export const KokonTooltipIcon: React.FC = (): React.JSX.Element => {
  return (
    <TooltipDesktop title={<KokonTooltipContent />} theme="white" placement="right-start">
      <div className={styles['icon-wrapper']}>
        <KokonIcon16 />
      </div>
    </TooltipDesktop>
  );
};
